/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import {
  Box,
  Paper,
  Grid,
  Typography,
  Chip,
  CircularProgress,
  Stack,
  useTheme,
  LinearProgress,
  Card,
  CardContent,
  Divider,
  Button,
  TextField,
} from "@mui/material";
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Event as EventIcon,
  People as PeopleIcon,
  Storage as StorageIcon,
  CreditCard as CreditCardIcon,
  Business as BusinessIcon,
  Timeline as TimelineIcon,
  Assignment as AssignmentIcon,
  AttachMoney as MoneyIcon,
  TrendingUp as TrendingUpIcon,
} from "@mui/icons-material";

// import { useTheme } from "@mui/material";


import LockResetIcon from "@mui/icons-material/LockReset";


import { getUserSubscription } from "services/subscription/subscriptionService";
import profileSvg from "assets/folders/profile.svg";
// import userRole from "utils/role";
import { getSecureLocalItem } from "utils/secureSessionStorage";
import { resetPasswordAction } from "store/features/auth/authActions";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

const Profile = () => {
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [features, setFeatures] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSubscription();
  }, []);


  const role = getSecureLocalItem("role") || "admin";
  const userRaw = getSecureLocalItem("user");
  const user = userRaw ? JSON.parse(userRaw) : null;
  const name = user?.first_name + " " + user?.last_name || "User";
  const email = user?.email;
  const emailUsername = user?.email ? user.email.split('@')[0] : "User";
  console.log(name, "Name ==================================================>")
  console.log(role, "Role ==============================================>")

  const dispatch = useDispatch();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!password) {
      showErrorToast("Password is required.");
      return;
    }

    if (password !== confirmPassword) {
      showErrorToast("Passwords do not match.");
      return;
    }

    const response = await dispatch(
      resetPasswordAction({
        new_password: password,
      })
    );

    if (response.success) {
      setPassword("");
      setConfirmPassword("");
    }
  };
  const fetchSubscription = async () => {
    try {
      setLoading(true);
      const response = await getUserSubscription();

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        setSubscriptionData(response.data.subscription);
        setFeatures(response.data.features || []);
      } else {
        setError(response?.meta?.message || "Failed to fetch subscription");
      }
    } catch (err) {
      console.error("Error fetching subscription:", err);
      setError("Failed to load subscription data");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(parseFloat(price));
  };

  const getStatusColor = (status) => {
    const colors = {
      active: {
        bg: "#d1fae5",
        text: "#065f46",
        darkBg: "rgba(16,185,129,0.25)",
        darkText: "#6ee7b7",
      },
      trialing: {
        bg: "#fef3c7",
        text: "#92400e",
        darkBg: "rgba(245,158,11,0.25)",
        darkText: "#fde68a",
      },
      past_due: {
        bg: "#fee2e2",
        text: "#991b1b",
        darkBg: "rgba(239,68,68,0.25)",
        darkText: "#fca5a5",
      },
      canceled: {
        bg: "#f3f4f6",
        text: "#4b5563",
        darkBg: "rgba(107,114,128,0.25)",
        darkText: "#9ca3af",
      },
    };
    return colors[status] || colors.active;
  };

  const StatusBadge = ({ status }) => {
    const colors = getStatusColor(status);
    const getLabel = () => {
      switch (status) {
        case "active":
          return "Active";
        case "trialing":
          return "Trial Period";
        case "past_due":
          return "Past Due";
        case "canceled":
          return "Canceled";
        default:
          return status;
      }
    };

    return (
      <Chip
        icon={
          status === "active" ? (
            <CheckCircleIcon sx={{ fontSize: 14 }} />
          ) : (
            <EventIcon sx={{ fontSize: 14 }} />
          )
        }
        label={getLabel()}
        size="small"
        sx={{
          backgroundColor: colors.bg,
          color: colors.text,
          fontWeight: 500,
          fontSize: "0.75rem",
          height: "24px",
          ...(theme.palette.mode === "dark" && {
            backgroundColor: colors.darkBg,
            color: colors.darkText,
          }),
        }}
      />
    );
  };

  const FeatureBadge = ({ feature }) => {
    const isEnabled = feature.is_enabled === 1;
    return (
      <Chip
        icon={
          isEnabled ? (
            <CheckCircleIcon sx={{ fontSize: 12 }} />
          ) : (
            <CancelIcon sx={{ fontSize: 12 }} />
          )
        }
        label={
          feature.feature_key.charAt(0).toUpperCase() +
          feature.feature_key.slice(1)
        }
        size="small"
        sx={{
          backgroundColor: isEnabled ? "#d1fae5" : "#fee2e2",
          color: isEnabled ? "#065f46" : "#991b1b",
          fontWeight: 500,
          fontSize: "0.7rem",
          height: "28px",
          "& .MuiChip-label": { px: 1.5 },
          ...(theme.palette.mode === "dark" && {
            backgroundColor: isEnabled
              ? "rgba(16,185,129,0.25)"
              : "rgba(239,68,68,0.25)",
            color: isEnabled ? "#6ee7b7" : "#fca5a5",
          }),
        }}
      />
    );
  };

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          background:
            theme.palette.mode === "dark"
              ? "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)"
              : "linear-gradient(135deg, #ffffff 0%, #fffbeb 60%, #fef3c7 100%)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack alignItems="center" spacing={2}>
          <CircularProgress
            size={48}
            sx={{
              color: "primary.main",
              "& .MuiCircularProgress-circle": {
                strokeLinecap: "round",
              },
            }}
          />
          <Typography
            sx={{
              color: "text.secondary",
            }}
          >
            Loading subscription details...
          </Typography>
        </Stack>
      </Box>
    );
  }

  if (error || !subscriptionData) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          background:
            theme.palette.mode === "dark"
              ? "linear-gradient(135deg, #0a0f1e 0%, #0f172a 50%, #1e1b2e 100%)"
              : "linear-gradient(135deg, #fffbeb 0%, #ffffff 50%, #fefce8 100%)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 4,
            textAlign: "center",
            borderRadius: "16px",
            maxWidth: 400,
            bgcolor: "background.paper",
          }}
        >
          <BusinessIcon sx={{ fontSize: 48, color: "primary.main", mb: 2 }} />
          <Typography
            variant="h6"
            sx={{
              mb: 1,
              color: "text.primary",
            }}
          >
            No Subscription Found
          </Typography>
          <Typography
            sx={{
              color: "text.secondary",
            }}
          >
            {error ||
              "Unable to load subscription information. Please contact support."}
          </Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          theme.palette.mode === "dark"
            ? "linear-gradient(135deg, #0a0f1e 0%, #0f172a 50%, #1e1b2e 100%)"
            : "linear-gradient(135deg, #fffbeb 0%, #ffffff 50%, #fefce8 100%)",
        p: 3,
      }}
    >
      {/* Header Section */}
      <Box sx={{ mb: 4 }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Box
            component="img"
            src={profileSvg}
            alt="Profile"
            sx={{
              width: { xs: 64, lg: 80 },
              height: { xs: 64, lg: 80 },
              objectFit: "contain",
            }}
          />
          <Box>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: "bold",
                color: "text.primary",
              }}
            >
              {role == "Company" ? "Company Profile" : name + "'s" + " " + "Profile"}

            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                mt: 0.5,
              }}
            >
              {role == "Company" ? "View your subscription details and plan information" : "View your profile details and information"}
            </Typography>
          </Box>
        </Stack>
      </Box>
      {role == "Company" && (
        <Grid container spacing={4}>
          {/* Subscription Details Card */}
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              style={{ height: "100%" }}
            >
              <Card
                elevation={0}
                sx={{
                  borderRadius: "24px",
                  overflow: "hidden",
                  height: "100%",
                  background:
                    theme.palette.mode === "dark"
                      ? "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)"
                      : "linear-gradient(135deg, #ffffff 0%, #fefce8 100%)",
                  boxShadow:
                    theme.palette.mode === "dark"
                      ? "0 20px 35px -10px rgba(0,0,0,0.4), 0 0 0 1px rgba(245,158,11,0.1)"
                      : "0 20px 35px -10px rgba(0,0,0,0.1), 0 0 0 1px rgba(245,158,11,0.15)",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow:
                      theme.palette.mode === "dark"
                        ? "0 25px 40px -12px rgba(0,0,0,0.5), 0 0 0 1px rgba(245,158,11,0.2)"
                        : "0 25px 40px -12px rgba(0,0,0,0.15), 0 0 0 1px rgba(245,158,11,0.2)",
                  },
                }}
              >
                <Box
                  sx={{
                    background:
                      "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                    p: 2.5,
                    px: 3,
                  }}
                >
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography
                      variant="h6"
                      sx={{ color: "#ffffff", fontWeight: 700 }}
                    >
                      Subscription Details
                    </Typography>
                    <StatusBadge status={subscriptionData.status} />
                  </Stack>
                </Box>

                <CardContent sx={{ p: 3 }}>
                  <Stack spacing={2.5}>
                    {/* Plan Name - Left aligned label, right aligned value */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "text.secondary",
                          fontWeight: 500,
                        }}
                      >
                        Plan Name
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          color: "primary.main",
                          fontSize: "1.1rem",
                        }}
                      >
                        {subscriptionData.plan_name}
                      </Typography>
                    </Box>

                    <Divider
                      sx={{
                        borderColor:
                          theme.palette.mode === "dark" ? "#334155" : "#f3f4f6",
                      }}
                    />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "text.secondary",
                          fontWeight: 500,
                        }}
                      >
                        Plan Code
                      </Typography>
                      <Chip
                        label={subscriptionData.plan_code}
                        size="small"
                        sx={{
                          backgroundColor:
                            theme.palette.mode === "dark"
                              ? "rgba(245,158,11,0.15)"
                              : "#fef3c7",
                          color: "primary.main",
                          fontWeight: 600,
                          fontFamily: "monospace",
                          borderRadius: "8px",
                        }}
                      />
                    </Box>

                    <Divider
                      sx={{
                        borderColor:
                          theme.palette.mode === "dark" ? "#334155" : "#f3f4f6",
                      }}
                    />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "text.secondary",
                          fontWeight: 500,
                        }}
                      >
                        Price
                      </Typography>
                      <Stack direction="row" alignItems="center" spacing={0.5}>
                        <MoneyIcon sx={{ fontSize: 18, color: "primary.main" }} />
                        <Typography
                          sx={{
                            fontWeight: 700,
                            fontSize: "1.1rem",
                            color:
                              theme.palette.mode === "dark" ? "#fff" : "#1e293b",
                          }}
                        >
                          {formatPrice(subscriptionData.price)}
                        </Typography>
                        <Typography
                          sx={{
                            color:
                              theme.palette.mode === "dark"
                                ? "#64748b"
                                : "#9ca3af",
                            fontSize: "0.875rem",
                          }}
                        >
                          / {subscriptionData.billing_cycle}
                        </Typography>
                      </Stack>
                    </Box>

                    <Divider
                      sx={{
                        borderColor:
                          theme.palette.mode === "dark" ? "#334155" : "#f3f4f6",
                      }}
                    />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "text.secondary",
                          fontWeight: 500,
                        }}
                      >
                        Billing Cycle
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: 600,
                          textTransform: "capitalize",
                          color:
                            theme.palette.mode === "dark" ? "#fff" : "#1e293b",
                        }}
                      >
                        {subscriptionData.billing_cycle}
                      </Typography>
                    </Box>

                    {subscriptionData.trial_days > 0 &&
                      subscriptionData.is_trial_allowed === 1 && (
                        <>
                          <Divider
                            sx={{
                              borderColor:
                                theme.palette.mode === "dark"
                                  ? "#334155"
                                  : "#f3f4f6",
                            }}
                          />
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                color: "text.secondary",
                                fontWeight: 500,
                              }}
                            >
                              Trial Period
                            </Typography>
                            <Chip
                              label={`${subscriptionData.trial_days} days free`}
                              size="small"
                              sx={{
                                backgroundColor:
                                  theme.palette.mode === "dark"
                                    ? "rgba(16,185,129,0.15)"
                                    : "#d1fae5",
                                color: "#10b981",
                                fontWeight: 600,
                                borderRadius: "8px",
                              }}
                            />
                          </Box>
                        </>
                      )}
                  </Stack>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>

          {/* Period Details Card */}
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              style={{ height: "100%" }}
            >
              <Card
                elevation={0}
                sx={{
                  borderRadius: "24px",
                  overflow: "hidden",
                  height: "100%",
                  background:
                    theme.palette.mode === "dark"
                      ? "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)"
                      : "linear-gradient(135deg, #ffffff 0%, #fefce8 100%)",
                  boxShadow:
                    theme.palette.mode === "dark"
                      ? "0 20px 35px -10px rgba(0,0,0,0.4), 0 0 0 1px rgba(245,158,11,0.1)"
                      : "0 20px 35px -10px rgba(0,0,0,0.1), 0 0 0 1px rgba(245,158,11,0.15)",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow:
                      theme.palette.mode === "dark"
                        ? "0 25px 40px -12px rgba(0,0,0,0.5), 0 0 0 1px rgba(245,158,11,0.2)"
                        : "0 25px 40px -12px rgba(0,0,0,0.15), 0 0 0 1px rgba(245,158,11,0.2)",
                  },
                }}
              >
                <Box
                  sx={{
                    background:
                      "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                    p: 2.5,
                    px: 3,
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <TimelineIcon sx={{ color: "#ffffff" }} />
                    <Typography
                      variant="h6"
                      sx={{ color: "#ffffff", fontWeight: 700 }}
                    >
                      Period Details
                    </Typography>
                  </Stack>
                </Box>

                <CardContent sx={{ p: 3 }}>
                  <Stack spacing={2.5}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "text.secondary",
                          fontWeight: 500,
                        }}
                      >
                        Current Period Start
                      </Typography>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <EventIcon sx={{ fontSize: 16, color: "#10b981" }} />
                        <Typography
                          sx={{
                            fontWeight: 500,
                            color:
                              theme.palette.mode === "dark" ? "#fff" : "#1e293b",
                          }}
                        >
                          {formatDate(subscriptionData.current_period_start)}
                        </Typography>
                      </Stack>
                    </Box>

                    <Divider
                      sx={{
                        borderColor:
                          theme.palette.mode === "dark" ? "#334155" : "#f3f4f6",
                      }}
                    />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "text.secondary",
                          fontWeight: 500,
                        }}
                      >
                        Current Period End
                      </Typography>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <EventIcon sx={{ fontSize: 16, color: "#ef4444" }} />
                        <Typography
                          sx={{
                            fontWeight: 600,
                            color:
                              theme.palette.mode === "dark" ? "#fff" : "#1e293b",
                          }}
                        >
                          {formatDate(subscriptionData.current_period_end)}
                        </Typography>
                      </Stack>
                    </Box>

                    <Divider
                      sx={{
                        borderColor:
                          theme.palette.mode === "dark" ? "#334155" : "#f3f4f6",
                      }}
                    />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "text.secondary",
                          fontWeight: 500,
                        }}
                      >
                        Cancel at Period End
                      </Typography>
                      <Chip
                        label={
                          subscriptionData.cancel_at_period_end === 1
                            ? "Canceling"
                            : "Active"
                        }
                        size="small"
                        sx={{
                          backgroundColor:
                            subscriptionData.cancel_at_period_end === 1
                              ? theme.palette.mode === "dark"
                                ? "rgba(239,68,68,0.15)"
                                : "#fee2e2"
                              : theme.palette.mode === "dark"
                                ? "rgba(16,185,129,0.15)"
                                : "#d1fae5",
                          color:
                            subscriptionData.cancel_at_period_end === 1
                              ? "#ef4444"
                              : "#10b981",
                          fontWeight: 600,
                          borderRadius: "8px",
                        }}
                      />
                    </Box>

                    <Divider
                      sx={{
                        borderColor:
                          theme.palette.mode === "dark" ? "#334155" : "#f3f4f6",
                      }}
                    />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "text.secondary",
                          fontWeight: 500,
                        }}
                      >
                        Max Users
                      </Typography>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <PeopleIcon sx={{ fontSize: 16, color: "primary.main" }} />
                        <Typography
                          sx={{
                            fontWeight: 700,
                            color:
                              theme.palette.mode === "dark" ? "#fff" : "#1e293b",
                          }}
                        >
                          {subscriptionData.max_users}
                        </Typography>
                      </Stack>
                    </Box>

                    <Divider
                      sx={{
                        borderColor:
                          theme.palette.mode === "dark" ? "#334155" : "#f3f4f6",
                      }}
                    />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "text.secondary",
                          fontWeight: 500,
                        }}
                      >
                        Max Employees
                      </Typography>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <PeopleIcon sx={{ fontSize: 16, color: "primary.main" }} />
                        <Typography
                          sx={{
                            fontWeight: 700,
                            color:
                              theme.palette.mode === "dark" ? "#fff" : "#1e293b",
                          }}
                        >
                          {subscriptionData.max_employees}
                        </Typography>
                      </Stack>
                    </Box>

                    <Divider
                      sx={{
                        borderColor:
                          theme.palette.mode === "dark" ? "#334155" : "#f3f4f6",
                      }}
                    />

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "text.secondary",
                          fontWeight: 500,
                        }}
                      >
                        Storage Limit
                      </Typography>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <StorageIcon sx={{ fontSize: 16, color: "primary.main" }} />
                        <Typography
                          sx={{
                            fontWeight: 700,
                            color:
                              theme.palette.mode === "dark" ? "#fff" : "#1e293b",
                          }}
                        >
                          {subscriptionData.max_storage_mb} MB{" "}
                        </Typography>
                      </Stack>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>

          {/* Features Card - Full Width */}
          <Grid item xs={12}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
            >
              <Card
                elevation={0}
                sx={{
                  borderRadius: "24px",
                  overflow: "hidden",
                  background:
                    theme.palette.mode === "dark"
                      ? "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)"
                      : "linear-gradient(135deg, #ffffff 0%, #fefce8 100%)",
                  boxShadow:
                    theme.palette.mode === "dark"
                      ? "0 20px 35px -10px rgba(0,0,0,0.4), 0 0 0 1px rgba(245,158,11,0.1)"
                      : "0 20px 35px -10px rgba(0,0,0,0.1), 0 0 0 1px rgba(245,158,11,0.15)",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow:
                      theme.palette.mode === "dark"
                        ? "0 25px 40px -12px rgba(0,0,0,0.5), 0 0 0 1px rgba(245,158,11,0.2)"
                        : "0 25px 40px -12px rgba(0,0,0,0.15), 0 0 0 1px rgba(245,158,11,0.2)",
                  },
                }}
              >
                <Box
                  sx={{
                    background:
                      "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                    p: 2.5,
                    px: 3,
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <AssignmentIcon sx={{ color: "#ffffff" }} />
                    <Typography
                      variant="h6"
                      sx={{ color: "#ffffff", fontWeight: 700 }}
                    >
                      Included Features
                    </Typography>
                  </Stack>
                </Box>

                <CardContent sx={{ p: 3 }}>
                  <Grid container spacing={2}>
                    {features.map((feature, index) => (
                      <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                        <FeatureBadge feature={feature} />
                      </Grid>
                    ))}
                  </Grid>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>

          {/* Subscription ID Card */}
          <Grid item xs={12}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
            >
              <Card
                elevation={0}
                sx={{
                  borderRadius: "24px",
                  background:
                    theme.palette.mode === "dark"
                      ? "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)"
                      : "linear-gradient(135deg, #ffffff 0%, #fefce8 100%)",
                  boxShadow:
                    theme.palette.mode === "dark"
                      ? "0 20px 35px -10px rgba(0,0,0,0.4), 0 0 0 1px rgba(245,158,11,0.1)"
                      : "0 20px 35px -10px rgba(0,0,0,0.1), 0 0 0 1px rgba(245,158,11,0.15)",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow:
                      theme.palette.mode === "dark"
                        ? "0 25px 40px -12px rgba(0,0,0,0.5), 0 0 0 1px rgba(245,158,11,0.2)"
                        : "0 25px 40px -12px rgba(0,0,0,0.15), 0 0 0 1px rgba(245,158,11,0.2)",
                  },
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      justifyContent: "space-between",
                      alignItems: { xs: "flex-start", sm: "center" },
                      gap: { xs: 2, sm: 3 },
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      <CreditCardIcon sx={{ color: "primary.main" }} />
                      <Typography
                        sx={{
                          color: "text.secondary",
                          fontWeight: 500,
                        }}
                      >
                        Subscription ID:
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "monospace",
                          fontWeight: 700,
                          color: "primary.main",
                          fontSize: "1rem",
                        }}
                      >
                        #{subscriptionData.subscription_id}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      <Typography
                        sx={{
                          color: "text.secondary",
                          fontWeight: 500,
                        }}
                      >
                        Tenant ID:
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "monospace",
                          fontWeight: 600,
                          color:
                            theme.palette.mode === "dark" ? "#fff" : "#1e293b",
                        }}
                      >
                        {subscriptionData.tenant_id}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        </Grid>

      )}

      {role === "Employee" && (
        <Paper
          elevation={0}
          sx={{
            maxWidth: 520,
            // mx: "auto",
            mt: 6,
            borderRadius: "12px",
            overflow: "hidden",
            // border: "1px solid #e2e8f0",
            backgroundColor: "transparent",

            // ...(theme.palette.mode === "dark" && {
            //   border: "1px solid #1e293b",
            // }),
          }}
        >
          {/* Header */}
          <Box
            sx={{
              px: 3,
              py: 2.5,
              // borderBottom: "1px solid #e2e8f0",

              // ...(theme.palette.mode === "dark" && {
              //   borderBottom: "1px solid #1e293b",
              // }),
            }}
          >
            <Stack direction="row" spacing={2} alignItems="center">
              <LockResetIcon sx={{ color: "primary.main", fontSize: 28 }} />

              <Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    color: "#111827",

                    ...(theme.palette.mode === "dark" && {
                      color: "#f8fafc",
                    }),
                  }}
                >
                  Reset Password
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    mt: 0.5,
                    color: "#6b7280",

                    ...(theme.palette.mode === "dark" && {
                      color: "#94a3b8",
                    }),
                  }}
                >
                  Set a new password before accessing your account.
                </Typography>
              </Box>
            </Stack>
          </Box>

          {/* Form */}
          <Box
            component="form"
            onSubmit={handleResetPassword}
            sx={{
              p: 3,
            }}
          >
            <Stack spacing={3}>
              <Box>
                <Typography
                  sx={{
                    mb: 1,
                    fontSize: "0.85rem",
                    fontWeight: 500,
                    color: "#374151",

                    ...(theme.palette.mode === "dark" && {
                      color: "#f1f5f9",
                    }),
                  }}
                >
                  New Password <span style={{ color: "#ef4444" }}>*</span>
                </Typography>

                <TextField
                  fullWidth
                  size="small"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      backgroundColor: "#fff",

                      ...(theme.palette.mode === "dark" && {
                        backgroundColor: "#0f172a",
                        color: "#fff",
                      }),

                      "& fieldset": {
                        borderColor: "#e2e8f0",

                        ...(theme.palette.mode === "dark" && {
                          borderColor: "#334155",
                        }),
                      },

                      "&:hover fieldset": {
                        borderColor: "#f59e0b",
                      },

                      "&.Mui-focused fieldset": {
                        borderColor: "#f59e0b",
                      },
                    },
                  }}
                />
              </Box>

              <Box>
                <Typography
                  sx={{
                    mb: 1,
                    fontSize: "0.85rem",
                    fontWeight: 500,
                    color: "#374151",

                    ...(theme.palette.mode === "dark" && {
                      color: "#f1f5f9",
                    }),
                  }}
                >
                  Confirm Password <span style={{ color: "#ef4444" }}>*</span>
                </Typography>

                <TextField
                  fullWidth
                  size="small"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      backgroundColor: "#fff",

                      ...(theme.palette.mode === "dark" && {
                        backgroundColor: "#0f172a",
                        color: "#fff",
                      }),

                      "& fieldset": {
                        borderColor: "#e2e8f0",

                        ...(theme.palette.mode === "dark" && {
                          borderColor: "#334155",
                        }),
                      },

                      "&:hover fieldset": {
                        borderColor: "#f59e0b",
                      },

                      "&.Mui-focused fieldset": {
                        borderColor: "#f59e0b",
                      },
                    },
                  }}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    px: 5,
                    py: 1,
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: 600,
                    backgroundColor: "#f59e0b",

                    "&:hover": {
                      backgroundColor: "#d97706",
                    },
                  }}
                >
                  Reset Password
                </Button>
              </Box>
            </Stack>
          </Box>
        </Paper>
      )}
    </Box>
  );
};

export default Profile;
